$(document).ready(function() {
  var metafield = $('.t4s-tab-wrapper').data('id-symbol-fmp') || "";
  var param;  
  if (metafield.trim() !== "") {param = metafield;} 
  else {param = document.URL.split("products/")[1].split("?")[0].toUpperCase();}  
    $.getJSON('https://financialmodelingprep.com/api/v3/balance-sheet-statement/'+param+'?period=quarter&limit=1&apikey=3ccf620ce9315de8a4996e601373f716', function(data){
      $.each(data, function(i, elem){
          

/*Это Balance Sheet*/
        
         if (elem.cashAndCashEquivalents == null) {var cashAndCashEquivalents_var = 'n/a';} else
         {var cashAndCashEquivalents_var = nFormatter(elem.cashAndCashEquivalents, 2);}
         $('#stat_cash_cash_equivalents').append(cashAndCashEquivalents_var);
         $('#stat_cash_cash_equivalents2').append(cashAndCashEquivalents_var);        

         if (elem.totalDebt == null) {var totalDebt_var = 'n/a';} else
         {var totalDebt_var = nFormatter(elem.totalDebt, 2);}
         $('#stat_total_debt').append(totalDebt_var);
         $('#stat_total_debt2').append(totalDebt_var);
         
         var netcash_var_calc = elem.cashAndCashEquivalents - elem.totalDebt;
         var netcash_var = nFormatter(netcash_var_calc, 2);
         $('#stat_net_cash').append(netcash_var);
         $('#stat_net_cash2').append(netcash_var);
         
        
         if (elem.totalStockholdersEquity == null) {var totalStockholdersEquity_var = 'n/a';} else
         {var totalStockholdersEquity_var = nFormatter(elem.totalStockholdersEquity, 2);}
         $('#stat_book_value').append(totalStockholdersEquity_var);


        
        
      });
    })
});